import { Box, TableCell, TableCellProps } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC, PropsWithChildren } from 'react'
import tableBodyCellStyles from '../../utils/components/CustomTable/styles/tableBodyCellStyles'
import { getStyles } from '../../utils/utils/commonUtils'

type TableBodyCellProps = TableCellProps &
  PropsWithChildren & {
    propKey?: string
    paddingLeftKeys?: string[]
    backgroundColor?: string
    width?: string
    height?: string
    customPadding?: string
  }

const TableBodyCell: FC<TableBodyCellProps> = ({
  children,
  propKey,
  paddingLeftKeys = [],
  align,
  backgroundColor,
  width,
  customPadding,
  height,
  ...otherProps
}) => {
  const bodyCellClasses = getStyles(tableBodyCellStyles, { minWidth: 'auto' })
  return (
    <TableCell
      className={'fx-nowrap'}
      sx={{
        // @ts-ignore
        ...bodyCellClasses.cell,
        backgroundColor: backgroundColor,
        minWidth: undefined,
        padding: customPadding,
        paddingLeft: paddingLeftKeys.includes(propKey ?? '')
          ? '20px'
          : undefined,
      }}
      align={align ?? 'left'}
      {...otherProps}
    >
      <Box sx={{ width, height }}>{children}</Box>
    </TableCell>
  )
}

export default observer(TableBodyCell)
